import { render, staticRenderFns } from "./WmaMessageReply.vue?vue&type=template&id=9b979f46&"
import script from "./WmaMessageReply.vue?vue&type=script&lang=js&"
export * from "./WmaMessageReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports